<template>
  <div class="comp-time">
    <h1 class="headline">TIME</h1>

    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-gray icon-printer" @click="printTimesheets">&nbsp;Export to CSV</button>
      </div>
      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH..." v-model="keyword" @change="doPaging(1)">
        </div>
        <v-select v-model="ftClientId" :options="allClients" class="ft-client" :reduce="item => item.id"
          label="name" :searchable="true"  placeholder="ALL CLIENTS"></v-select>
        <v-select v-if="IS_SUPER_ADMIN" v-model="ftUserId" :options="allStaff" class="ft-staff" :reduce="item => item.id"
                  label="full_name" :searchable="true"  placeholder="ALL USERS"></v-select>
        <date-picker format="DD-MM-YYYY" v-model="ftDateRange" :range="true" :editable="false"
          placeholder="DATE RANGE"></date-picker>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-time">
        <colgroup>
          <col width="20">
          <col width="120">
          <col width="250">
          <col>
          <col width="120">
        </colgroup>
        <thead>
          <tr>
            <th colspan="2"><a href="javascript:;">JOB NO</a></th>
            <th><a href="javascript:;">CLIENT</a></th>
            <th><a href="javascript:;">JOB NAME</a></th>
            <th><a href="javascript:;">TIME</a></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(job, index) in filteredJobs">
            <tr :key="index + '_job'" :class="{'time-row': true, 'active': index == activeIndex}" @click="switchTimeIndex( index )">
              <td><span class="icon-arrow"></span></td>
              <td>{{ job.id }}</td>
              <td>{{ job.client.name }}</td>
              <td>{{ job.name }}</td>
              <td>{{ job.duration | numberFormat }}h</td>
            </tr>
            <tr :key="index + '_timesheet'" v-if="activeIndex == index" class="time-details">
              <td colspan="5">
                <table-time-details class="tbl-time-details" :job_name="job.name" :client_name="job.client.name" :records="job.direct_timesheets" v-if="job.direct_timesheets.length"></table-time-details>
                <table-time-tasks :job_name="job.name" :client_name="job.client.name" :tasks="job.tasks" v-if="job.tasks.length"></table-time-tasks>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div v-if="hasFilters && jobs.length == 0" class="alert alert-warning">No records found</div>
    <div class="d-flex justify-content-between">
      <pagination :total-pages="totalPages" :current-page="currentPage" @goto-page="doPaging"></pagination>
    </div>
  </div>
</template>

<script>

  import { mapGetters, mapState } from 'vuex'
  import DatePicker from 'vue2-datepicker';
  import TableTimeDetails from './TableTimeDetails.vue';
  import TableTimeTasks from './TableTimeTasks.vue';
  import ServiceTimesheet from '@/services/timesheet'
  import dayjs from 'dayjs'
  import relativeTime from 'dayjs/plugin/relativeTime'
  import advancedFormat from 'dayjs/plugin/advancedFormat'
  // Import date picker css
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

  dayjs.extend(relativeTime)
  dayjs.extend(advancedFormat)

export default {
  components: {
    DatePicker,
    TableTimeDetails,
    TableTimeTasks,
  },
  data () {
    return {
      ftClientId: '',
      ftUserId: '',
      ftDateRange: '',
      currentPage: 1,
      totalPages: 0,
      jobs: [],
      client_id: null,
      keyword: '',
      activeIndex: -1,
      ftOptions: {}
    }
  },
  watch: {
    ftClientId: function () {
      this.doPaging(1);
    },
    ftUserId: function () {
      this.doPaging(1);
    },
    ftDateRange: function () {
      this.doPaging(1);
    }
  },
  computed: {
    ...mapGetters(['IS_CLIENT', 'CURRENT_USER', 'IS_SUPER_ADMIN']),
    ...mapState({
      allClients: state => state.option.clients,
      allStaff: state => state.option.users
    }),
    hasFilters () {
      let self = this;
      return self.ftClientId != '' || self.ftUserId != '' || self.ftDateRange != '' || self.keyword != '';
    },
    filteredJobs() {
      let self = this, filteredJobs = [];
      if (self.ftOptions.user_id || self.ftOptions.date_start) {
        for(let i in self.jobs) {
          self.jobs[i].duration = 0;
          if (self.jobs[i].direct_timesheets.length) {
            let direct_timesheets = self._filterTimesheet(self.jobs[i].direct_timesheets);
            self.jobs[i].direct_timesheets = direct_timesheets;
            self.jobs[i].duration += self._totalDuration(direct_timesheets);
          }

          if (self.jobs[i].tasks.length) {
            let notEmptyTasks = [];
            for(let idx in self.jobs[i].tasks) {
              if (self.jobs[i].tasks[idx].timesheets.length) {
                let task_timesheets = self._filterTimesheet(self.jobs[i].tasks[idx].timesheets);
                if (task_timesheets.length) {
                  self.jobs[i].tasks[idx].timesheets = task_timesheets;
                  self.jobs[i].duration += self._totalDuration(task_timesheets);
                  notEmptyTasks.push(self.jobs[i].tasks[idx]);
                }
              }
            }
            self.jobs[i].tasks = notEmptyTasks;
          }
          filteredJobs.push(self.jobs[i]);
        }
      } else {
        for(let i in self.jobs) {
          if (self.jobs[i].tasks.length) {
            let notEmptyTasks = [];
            for(let idx in self.jobs[i].tasks) {
              if (self.jobs[i].tasks[idx].timesheets.length) {
                notEmptyTasks.push(self.jobs[i].tasks[idx]);
              }
            }
            self.jobs[i].tasks = notEmptyTasks;
          }
          filteredJobs.push(self.jobs[i]);
        }
      }
      return filteredJobs;
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    _filterTimesheet(timesheets) {
      let self = this, filteredTimesheets = [];
      if (self.ftOptions.user_id || self.ftOptions.date_start) {
        for(let i in timesheets) {
          if (self.ftOptions.user_id && timesheets[i].user_id != self.ftOptions.user_id) {
            continue;
          }
          if (self.ftOptions.date_start) {
            let session_date = new Date(timesheets[i].session_date);
            let date_start = new Date(self.ftOptions.date_start);
            let date_end = new Date(self.ftOptions.date_end);
            if(date_start.getTime() > session_date.getTime() || date_end.getTime() < session_date.getTime()){
              continue;
            }
          }
          filteredTimesheets.push(timesheets[i]);
        }
        return filteredTimesheets;
      }
      return timesheets;
    },
    _totalDuration(timesheets) {
      let total = 0;
      for(let i in timesheets) {
        total += parseFloat(timesheets[i].duration);
      }
      return total;
    },
    init () {
      let self = this;
      if(self.IS_CLIENT)
        self.client_id = self.CURRENT_USER.client_id;
      self.ftUserId = self.IS_SUPER_ADMIN ? '' : self.CURRENT_USER.id;
      self.getJobsWithTimesheets();
    },
    switchTimeIndex ( index ) {
      let self = this;
      if ( self.activeIndex == index ) {
        self.activeIndex = -1;
      }
      else {
        self.activeIndex = index;
      }
    },
    doPaging ( page ) {
      let self = this;
      self.currentPage = page;
      self.getJobsWithTimesheets();
    },
    _getParams(){
      let self = this,
        params = {
          page: self.currentPage,
        };
      if ( self.ftClientId !== '' ) {
        params.client_id = self.ftClientId;
      }
      if ( self.ftUserId !== '' ) {
        params.user_id = self.ftUserId;
      }
      if ( self.ftDateRange !== '' && self.ftDateRange.length == 2 && self.ftDateRange[0] && self.ftDateRange[1]) {
        params.date_start = dayjs(self.ftDateRange[0]).format('YYYY-MM-DD');
        params.date_end = dayjs(self.ftDateRange[1]).format('YYYY-MM-DD');
      }
      if ( self.keyword !== '' ) {
        params.kw = self.keyword;
      }

      if(self.IS_CLIENT){
        params['client_id'] = self.CURRENT_USER.client_id;
      }
      self.ftOptions = params;
      return params;
    },
    getJobsWithTimesheets () {
      let self = this, params = self._getParams();
      ServiceTimesheet.getJobsWithTimesheets(params, resp => {
        self.jobs = resp.data;
        self.totalPages = resp.last_page;
        self.totalItems = resp.total;
      });
    },
    printTimesheets () {
      let self = this, params = self._getParams();
      ServiceTimesheet.printTimesheets(params, resp => {
        window.downloadFromBlob(resp.data, 'timesheets.csv');
      });
    }
  }
}
</script>
